@if(!isFreePlan()){
<app-container class="md:block hidden">
    <main class="flex flex-col gap-6 pt-[5rem]">
        <section class="flex border divide-x">
            <button routerLink="/administration/center-stat" class="segment" [class.active]="segment() === 'center-stat'">센터 통계</button>
            <button routerLink="/administration/accounting" class="segment" [class.active]="segment() === 'accounting'">센터 회계</button>
            <button routerLink="/administration/hrm" class="segment" [class.active]="segment() === 'hrm'">인사 관리</button>
        </section>
        <router-outlet />
    </main>
</app-container>

<div class="md:hidden flex items-center justify-center w-full h-dvh">
    <div class="flex flex-col gap-2.5 items-center justify-center">
        <app-icon name="ic:baseline-app-blocking" class="text-gray-400" />
        <p class="text-gray-500">행정관리는 태블릿/웹에서만 조회가능합니다.</p>
    </div>
</div>
} @else {
<div class="p-4 pt-[10rem] flex flex-col gap-6">
    <div class="flex flex-col gap-3 items-center">
        <img src="no-permission.png" class="size-[5.375rem]" />
        <p class="text-center text-gray-800 text-xl font-semibold">권한이 없습니다.</p>
    </div>
    <p class="text-gray-500 text-center">해당 센터의 메뉴에 대한 권한이 없어 접근할 수 없습니다.</p>
</div>
}
